import { Model } from "@vuex-orm/core";
import Customer from "./Customer";

export default class BizReviewFeedback extends Model {
  static entity = "bizReviewFeedbacks";

  static fields() {
    return {
      id: this.attr(),
      customerId: this.attr(),
      customer: this.belongsTo(Customer, "customerId"),
      message: this.attr(),
      createdAt: this.attr()
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
